import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} VehicleImage
 * @property {Id} imageId - Image ID
 * @property {ISO8601} [createTime] - Image create time
 * @property {string} [fileName] - Image original filename
 * @property {boolean} [isUploaded] - Indicates image file is uploaded on webdav store
 * @property {string} [mimeType] - The MIME type of the image
 * @property {ISO8601} [modifyTime] - Image modify time
 */
export const vehicleImagePropType = PropTypes.shape({
    createTime: iso8601PropType,
    fileName: PropTypes.string,
    imageId: idPropType.isRequired,
    isUploaded: PropTypes.bool,
    mimeType: PropTypes.string,
    modifyTime: iso8601PropType
})
